<template>
  <div class="edit-studio-container">
    <main class="tab-content">
      <h2 class="item text-secondary">Studio contact content:</h2>
      <div class="btn-container">
        <span id="cancelUser" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <form class="form-container admin-studio-tab-pane fade show active" id="admin_user_info">
        <div class="field-sec">
          <label>Opening time text:</label>
          <input type="text" class="form-control" v-model="fit20.blockToEdit.openingTime" />
        </div>
      </form>
      <div class="btn-container">
        <span id="cancelUser2" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser2" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
      <br>
      <h3 class="text-secondary">Example:</h3>
      The example is from the first studio in the sheet and the map it is just for test:
      <br>
      <div id="fit20_contact" class="fit20-contact">
        <div class="fit20-contact-container">
          <div id="fit20_studio_address" class="fit20-studio-address not-fixed">
            <h3 id="fit20_studio_address_title" class="fit20-studio-address-title"></h3>
            <div id="fit20_studio_address_text" class="fit20-studio-address_text not-fixed"></div>
          </div>
          <div id="studio_location_map" class="studio-location-map"></div>
          <div id="fit20_opening_time" class="fit20-opening-time">
            <h3 id="fit20_opening_time_title" class="fit20-opening-time-title"></h3>
            <div id="fit20_opening_time_text" class="fit20-opening-time-text not-fixed"></div>
          </div>
        </div>
      </div>
      <div class="btn-container">
        <span id="cancelUser3" class="fit20-btn cancel-btn-disable" @click="cancelEditing">cancel</span>
        <span id="saveUser3" class="fit20-btn save-btn-disable" @click="saveBlock">publish</span>
      </div>
    </main>

  </div>
</template>

<script>

export default {
  name: 'StudioContact',
  props: ["fit20", "saveBlock", "cancelEditing"],
  methods: {
    getContactBlockData: (newsStaticContentContact) => {
      let iframeStudioLocation =
        '<iframe width="100%" height="350" frameborder="0" src="https://maps.google.com/maps?width=100%25&amp;height=350&amp;hl=nl&amp;q=fit20%20alphenaandenrijn&output=embed"></iframe>';
      const formatDate = (date) => {
        const [day, month, year] = date.split('/');
        const dateInUTC = Date.UTC(year, month - 1, day);
        return new Date(dateInUTC);
      };

      let contactBlockData;
      try {


        const contactStdioName = document.getElementById('fit20_studio_address_title');
        const addressText = document.getElementById('fit20_studio_address_text');
        const studioLocation = document.getElementById('studio_location_map');
        const openingTimeTitle = document.getElementById('fit20_opening_time_title');
        const openingTimeText = document.getElementById('fit20_opening_time_text');
        contactStdioName.innerHTML = "fit20 test";
        addressText.innerHTML = `test test
        test
        765645 test`.replace(/\n/g, '<br>');
        studioLocation.innerHTML = iframeStudioLocation;
        openingTimeTitle.innerHTML = newsStaticContentContact.openingTime;
        const scheduleData = `Mo 08:00 - 20:00
Tu 08:00 - 20:00
We 08:00 - 20:00
Th 08:00 - 20:00
Fr 08:00 - 20:00
Sa Closed
Su Closed`;

        // Split the data into lines
        const lines = scheduleData.split('\n');

        // Create a table element
        const table = document.createElement('table');
        openingTimeText.innerHTML = "";
        // Append the table to the container
        openingTimeText.appendChild(table);

        // Loop through the lines and create rows and cells
        lines.forEach((line) => {
          const [day, timeRange, dash, closeTime, extra, extra2] = line.split(' ');

          // Create a table row
          const row = document.createElement('tr');

          // Create two cells in the row
          const cell1 = document.createElement('td');
          const cell2 = document.createElement('td');
          cell1.textContent = day;
          cell2.textContent =

            // Set the content of the cells
            cell1.textContent = day;
          cell2.textContent =
            timeRange +
            ' ' +
            (dash ? dash : '') +
            ' ' +
            (closeTime ? closeTime : '') +
            ' ' +
            (extra ? extra : '') +
            ' ' +
            (extra2 ? extra2 : '');

          // Append the cells to the row
          row.appendChild(cell1);
          row.appendChild(cell2);

          // Append the row to the table
          table.appendChild(row);
        });
      } catch (err) {
        console.log(err);
        window.alert("Something went wrong please try to add a correct sheet id!");
      }
      // return filteredArrayOfObjectsData[0];
    }
  },
  async mounted() {
    this.getContactBlockData(this.fit20.blockToEdit);
  },
  watch: {
    "fit20.blockToEdit": {
      deep: true, // Watch for changes in nested properties
      handler(newVal, oldVal) {
        const openingTimeTitle = document.getElementById('fit20_opening_time_title');
        if (openingTimeTitle) {
          openingTimeTitle.innerHTML = newVal.openingTime;
        }
      }
    },
  }
};
</script>

<style scoped>
.edit-studio-container {
  width: 100%;
  overflow: auto;
}

.tab-content {
  padding-top: 15px;
}

.tab-content h2 {
  margin-left: 10px;
}

.img-container img {
  border-radius: 15px;
  cursor: pointer;
  max-width: 150px;
}

.admin-studio-tab-pane {
  display: none;
  padding-bottom: 30px;
}

.form-container.active {
  display: flex !important;
  flex-wrap: wrap;
  justify-content: space-around;
}

.form-container div {
  width: calc(100% / 2 - 30px);
}

.form-container label {
  display: block;
}

.studio-users {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
}

.users-col {
  width: calc(100%);
}

.studio-machines {
  width: 100%;
}

.ex-member-container {
  margin-top: 10px;
}

.ex-member-flex {
  width: 100% !important;
}

.ex-member-item {
  width: 80% !important;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px 7px;
  border-radius: 10px;
  margin-bottom: 7px;
}

.ex-member-container img {
  margin-bottom: 7px;

}

.measure-div {
  position: relative;
}

.kg {
  position: absolute;
  right: 60px;
  bottom: 5px;
}

/*  CSS of the displayed block*/
.fit20-contact {
  width: 100%;
  max-width: 1500px;
  min-height: 500px;
  background-color: rgba(0, 159, 227, 0.13);
}

.fit20-contact-container {
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 500px;
}

.fit20-studio-address,
.studio-location-map,
.fit20-opening-time {
  width: calc(100% / 3 - 20px);
  background-color: white;
  height: 350px;
  border-radius: 15px;
}

.studio-location-map iframe {
  border-radius: 20px;
}

.fit20-studio-address h3,
.fit20-opening-time h3 {
  padding: 0 25px;
  padding-top: 15px;
  padding-bottom: 15px;
  font-size: 25px !important;
}

.fit20-studio-address div,
.fit20-opening-time div {
  padding: 0 25px;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 14px !important;
  color: black !important;
  font-weight: 550;
}

.fit20-studio-address_text,
.fit20-opening-time-text table {
  line-height: 25px;
  font-family: 'Open Sans', sans-serif !important;
  font-size: 14px !important;
  color: black !important;
  width: fit-content !important;
  font-weight: 550;
}

.fit20-opening-time-text table {
  border: none;
}

.fit20-opening-time-text table td {
  color: black !important;
  border-block-end-width: 0px !important;
  border-block-end-style: none !important;
  border-block-end-color: transparent !important;
  padding: 3px !important;
  border-inline-end-width: 0px !important;
  border-inline-end-style: none !important;
  border-inline-end-color: transparent !important;
  width: fit-content !important;
  font-size: 14px !important;
  color: black !important;
  font-weight: 550 !important;
}

@media only screen and (max-width: 1060px) {
  .fit20-contact-container {
    width: 97%;
  }

  .fit20-studio-address,
  .studio-location-map,
  .fit20-opening-time {
    width: calc(100% / 3 - 20px);
  }
}

@media only screen and (max-width: 950px) {
  .fit20-contact-container {
    width: 90%;
    flex-wrap: wrap;
  }

  .fit20-studio-address,
  .studio-location-map,
  .fit20-opening-time {
    width: 100%;
    margin-top: 20px;
  }

  .fit20-studio-address {
    margin-top: 40px;
  }

  .fit20-opening-time {
    margin-bottom: 40px;
  }
}
</style>
